module.exports = __webpack_public_path__ + "static/media/login.786e7ac2.svg";